var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$attrs.type === "checkbox"
    ? _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.val,
                expression: "val"
              }
            ],
            ref: "input",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.val)
                ? _vm._i(_vm.val, null) > -1
                : _vm.val
            },
            on: {
              input: function($event) {
                return _vm.updateValue($event.target.value)
              },
              change: [
                function($event) {
                  var $$a = _vm.val,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.val = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.val = $$c
                  }
                },
                _vm.emitChange
              ]
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      )
    : _vm.$attrs.type === "radio"
    ? _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.val,
                expression: "val"
              }
            ],
            ref: "input",
            attrs: { type: "radio" },
            domProps: { checked: _vm._q(_vm.val, null) },
            on: {
              input: function($event) {
                return _vm.updateValue($event.target.value)
              },
              change: [
                function($event) {
                  _vm.val = null
                },
                _vm.emitChange
              ]
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      )
    : _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.val,
                expression: "val"
              }
            ],
            ref: "input",
            attrs: { type: _vm.$attrs.type },
            domProps: { value: _vm.val },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.val = $event.target.value
                },
                function($event) {
                  return _vm.updateValue($event.target.value)
                }
              ],
              change: _vm.emitChange
            }
          },
          "input",
          _vm.$attrs,
          false
        )
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37001c7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37001c7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/input/RegexInput.vue
// module id = null
// module chunks = 